<div class="signature-pad-wrapper">
  <canvas #canvas class="signature-pad-canvas"></canvas>
  <div class="signature-pad-actions">
    <tidy-text
      [actionBody]="'Clear'"
      (action)="clear()"
      class="link" />
  </div>
</div>
